module.exports = __webpack_public_path__ + "static/media/view10_front.cfb82289.png";